import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Col, Container, Row } from 'reactstrap';
import Sidebar from './Sidebar';
import CardsClass from './Cards';

const JobCardsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Cards View' parent='Job Search' title='Cards View' />
      <Row>
        <Sidebar />
        <Col className='col-xxl-9 col-xl-8 box-col-8 col-auto'>
          <Row>
            <CardsClass limit={14} jobClass={'col-xl-6 box-col-6'} ribbion={true} />
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default JobCardsContainer;
